<template>
  <button
    @click="openCreateOfferOpen({ offerName: name, source: 'grid' })"
    class="tw:flex-1 tw:rounded-xl tw:p-5 tw:flex tw:flex-row tw:text-left tw:items-center tw:justify-between tw:gap-x-2 tw:w-full"
    :disabled="status === 'COMING_SOON'"
    :class="
      status === 'ACTIVE'
        ? 'active:tw:bg-blue-300 tw:hover:bg-blue-100 tw:bg-white shadow tw:text-black active:tw:text-blue-700'
        : 'tw:bg-gray-200 tw:text-gray-600'
    "
    :data-testid="`hotel-offer-item-${category}-${name}-${status}`"
  >
    <div>
      <img
        :src="icon"
        class="tw:h-[36px] tw:w-[36px] tw:mb-4"
        :class="{ 'tw:grayscale tw:opacity-70': status === 'COMING_SOON' }"
      />
      <p v-if="status === 'COMING_SOON'" class="tw:font-bold tw:text-xs tw:color-gray-600 tw:mb-2">
        {{ $t('hotel_offers_coming') }}
      </p>
      <p v-if="isNewOffer" class="tw:font-bold tw:text-xs tw:text-red-700 tw:mb-2">
        {{ $t('hotel_offers_package_new_tag') }}
      </p>
      <h3 class="tw:text-xl tw:font-bold tw:mb-2">{{ $t(`ho_${name}_title`) }}</h3>
      <p>{{ $t(`ho_${name}_text`) }}</p>
    </div>
    <div v-if="status === 'ACTIVE'" class="tw:justify-end tw:flex">
      <ChevronRight class="tw:size-6" />
    </div>
  </button>
</template>

<script setup>
import { computed } from 'vue'
import ChevronRight from '@/components/icons/ChevronRight.svg?component'
import { NEW_OFFER_NAMES } from '@/constants/hotelOffersIcons'

const emit = defineEmits(['openCreateOfferOpen'])
const openCreateOfferOpen = ({ offerName, source }) => {
  emit('openCreateOfferOpen', { offerName, source })
}
const props = defineProps({
  name: String,
  category: String,
  icon: URL,
  status: String,
})

const isNewOffer = computed(() => NEW_OFFER_NAMES.includes(props.name))
</script>
